<div class="main">
<kendo-grid [sort]="DataService.state.sort" [dir]="biService.getDir() ? 'rtl': 'ltr'" #Grid [filterable]="'menu'"
  [data]="GridData | async" [height]="height ? height : 500" [sortable]="true" [resizable]="true" [selectable]="true" kendoGridSelectBy
  [(selectedKeys)]="mySelection" (cellClick)="cellClickHandler($event)" (dataStateChange)="onValueChange($event)"
  (cellClose)="cellCloseHandler($event)" [kendoGridExpandDetailsBy]="expandDetailsBy"
  [(expandedDetailKeys)]="expandedDetailKeys" [filter]="Kendofilter" (filterChange)="filterChange($event)">
  <ng-container *ngFor="let res of Columns" [ngSwitch]="res.controlType">
    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'text'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <kendo-textbox [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
          [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''"
          (change)="bindingData($event, res.Name)"></kendo-textbox>
        <span *ngIf="formGroup.controls[res.Name].invalid">
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName}} {{'IsRequired' | translate}}
          </span>
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.email">
            {{'Emailaddressisinvalid' | translate}}
          </span>
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">
          {{ dataItem | getValue : res.Name}}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
                       *ngSwitchCase="'numeric'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
                       [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <input [formControl]="formGroup.controls[res.Name]" type="number" class="form-control"
               (change)="bindingData($event, res.Name)" [value]="formGroup.getRawValue()[res.Name]">
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">
          {{ dataItem | getValue : res.Name}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{
        dataItem | getValue : res.Name| number: res.Precision? '1.' + res.Precision + '-' + res.Precision :
        DefaultPrecision |negativeValueTransform
        }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'date'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <kendo-datepicker [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
          (valueChange)="bindingData($event, res.Name)" calendarType="classic"></kendo-datepicker>
        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem | getValue : res.Name | date: "medium"}}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" *ngSwitchCase="'boolean'"
      [filter]="res.DataType" [hidden]="!res.IsVisible" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridHeaderTemplate *ngIf="HasSelectAll || res?.checkboxTemplate?.HasSelectAll">
        <input type="checkbox" [(ngModel)]="selectAll" (change)="changeCheckAll($event, res.Name)">
        <span *ngIf=" res?.checkboxTemplate?.HasSelectAllLabel">
          {{'SelectAll' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex"
        *ngIf="res?.checkboxTemplate?.HasSelectAll">
        <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
          [checked]="dataItem[res.Name] || selectAll"
          [disabled]="!res.IsEditable||(IsDisabledCellTemplate(dataItem[this.RowIdentifier],res.Name)) " />
        <!-- <input type="checkbox" [checked]="dataItem[res.Name] || selectAll" [formControl]="formGroup.controls[res.Name]"
          [value]="formGroup.getRawValue()[res.Name]"/> -->
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="res?.checkboxTemplate?.HasSelectAll"
        let-rowIndex="rowIndex">
        <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
          [checked]="dataItem[res.Name] || selectAll"
          [disabled]="!res.IsEditable||(IsDisabledCellTemplate(dataItem[this.RowIdentifier],res.Name)) " />
      </ng-template>

      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-rowIndex="rowIndex"
        *ngIf="!res?.checkboxTemplate?.HasSelectAll">
        <input type="checkbox" [checked]="dataItem[res.Name]" [formControl]="formGroup.controls[res.Name]"
          [value]="formGroup.getRawValue()[res.Name]" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="!res?.checkboxTemplate?.HasSelectAll"
        let-rowIndex="rowIndex">
        <input type="checkbox" (change)="changeCheckBox($event, res.Name, dataItem, rowIndex)"
          [checked]="dataItem[res.Name]" [disabled]="formGroups[rowIndex].get(res.Name)?.disabled" />
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'select'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-dropdownlist [data]="res?.dropDownTemplate?.list" [textField]="'' + res?.dropDownTemplate?.text"
          [valueField]="''+res?.dropDownTemplate?.value"
          (valueChange)="filterByDropList($event, filterService, res.Name)" [valuePrimitive]="true">
        </kendo-dropdownlist>
      </ng-template>
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <bi-dropDown [Name]="res.Name" [DropDownList]="res?.dropDownTemplate?.list"
          [BindingProperty]="formGroup.controls[res.Name]" [ValueField]="res?.dropDownTemplate?.value"
          [TextField]="res?.dropDownTemplate?.text"
          (OnValueChange)="res?.dropDownTemplate?.OnValueChange($event)"></bi-dropDown>

        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [colorStatus]="{key: dataItem[res.Name], colors}">
          {{ GetDropDownTxtValueByCode(dataItem | getValue : res.Name, res?.dropDownTemplate) }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="'lookup'" [filter]="res.DataType" [field]="res.Name" [title]="res.DisplayName | translate"
      [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-formGroup="formGroup">
        <app-bi-lookup [BindingProperty]="formGroup.controls[res.Name]"
          [DataSource]="res.lookupTemplate?.['DataSource']" [Key]="res.lookupTemplate?.['Key']"
          [Title]="res.DisplayName" [DomID]="res.lookupTemplate?.['ID']" [DataType]="res.DataType"
          [hasSecondLkp]="res.lookupTemplate?.['hasSecondLkp'] ? true : false"
          (AfterLoad)="res.lookupTemplate?.AfterLoad && res.lookupTemplate?.AfterLoad()"
          (BeforeLoad)="res.lookupTemplate?.BeforeLoad && res.lookupTemplate?.BeforeLoad()"
          (OnClose)="res.lookupTemplate?.OnClose && res.lookupTemplate?.OnClose()"
          (OnOpen)="res.lookupTemplate?.OnOpen && res.lookupTemplate?.OnOpen()"
          (OnOpenSecondLkp)="res.lookupTemplate?.OnOpenSecondLkp && res.lookupTemplate?.OnOpenSecondLkp()"
          (ReturnedValueEmitter)="res.lookupTemplate?.ReturnedValueEmitter&&res.lookupTemplate?.ReturnedValueEmitter($event)"
          [setPreventCloseRow]="setPreventCloseRow" [classNameSelector]="'padding-button-reset btn btn-light'">
        </app-bi-lookup>
        <!-- (ErrorStateEmitter)="GetLookupErrorState($event, res.Name)"> -->

        <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
          {{res.DisplayName | translate}} {{'IsRequired' | translate}}
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem | getValue : res.Name }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [filterable]="res.IsFilterable" [sortable]="res.IsFilterable" [hidden]="!res.IsVisible"
      *ngSwitchCase="res.controlType==='logText'" [filter]="res.DataType" [field]="res.Name"
      [title]="res.DisplayName | translate" [width]="res.Width ? res.Width: 140">
      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
        <kendo-textbox [formControl]="formGroup.controls[res.Name]" [value]="formGroup.getRawValue()[res.Name]"
          (change)="bindingData($event, res.Name)"></kendo-textbox>
        <span *ngIf=" formGroup.controls[res.Name].invalid">
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.required">
            {{res.DisplayName | translate}} {{'IsRequired' | translate}}
          </span>
          <span class="text-danger" *ngIf="formGroup.controls[res.Name].errors?.email">
            {{'Emailaddressisinvalid' | translate}}
          </span>
        </span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div kendoButton *ngIf="!opened" (click)="open($event,res,dataItem)" class="kin-btn">
          {{dataItem[res.Name]?
          (res.ClickableText? res.ClickableText:dataItem[res.Name]):""}}
        </div>
        <kendo-dialog [title]="res.ModalTitle||'Message'" *ngIf="opened" (close)="close('cancel')" [minWidth]="250"
          [width]="'80%'">
          <p class="kin-dialog-text">{{DialogText}}</p>
        </kendo-dialog>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex">
      <BI-Nav [BIGrid]="filterInRefrenceChildren(dataItem, rowIndex)" [navButtons]="navButtonsLinesGroup"
        [DomID]="'customerCriteria_Nav'"
        [CanInsert]="!DisabledLinesGridChild && (!filterInRefrenceChildren(dataItem, rowIndex)?.CurrentSelectRow || filterInRefrenceChildren(dataItem, rowIndex).CurrentSelectRow?.status !== 'INVALID')"
        [CanDelete]="!DisabledLinesGridChild"></BI-Nav>
      <lib-bi-master-grid-details-children #masterGridDetailsChildren [colorsLines]="colorsLines"
        [DataService]="Getvalue(dataItem)['DataSource']" (AfterAddRow)="AfterAddRowLine(dataItem, rowIndex)"
        [changeSet]="changeSetLines" (BeforeAddRow)="BGridDetailsChildren_BeforeAddRow(dataItem)"
        (OnLoadData)="OnLoadDataDetails(dataItem, rowIndex)" [DomID]="dataItem[DomIDDetails]"
        (RowChangeMasterGridChangeDetails)="RowChangeDataDetails(dataItem, rowIndex)"
        [Columns]="ColumnsLines"></lib-bi-master-grid-details-children>
    </ng-template>
  </ng-container>
</kendo-grid>

<kendo-datapager *ngIf="HasPaging!=false" [dir]="biService.getDir() ? 'rtl': 'ltr'" class="mb-3 font-weight-bold "
  [total]="totalDataLength" [pageSize]="DataService.state.take ? DataService.state.take : 0"
  [skip]="DataService.state.skip ? DataService.state.skip : 0" (pageChange)="onPageChange($event)">
  <kendo-datapager-messages page="{{'page' | translate}}" of="{{'of' | translate}}"
    items="{{'vu_StockCheck' | translate}}" itemsPerPage="{{'items Per Page' | translate}}"></kendo-datapager-messages>
</kendo-datapager>
</div>